import axios from 'axios';
import { GOOGLE_API_KEY } from '../config';

export default async address =>
  await axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${GOOGLE_API_KEY}`
  );
